module.exports = __webpack_public_path__ + "static/img/sjbanner3.d37dd57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/sjbanner3.jpg
// module id = 00fp
// module chunks = 1